import data from "../../.sourceflow/main_menu.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getMainMenu = (locale = "en") => {
  const collection = new BaseCollection(data, locale).orderBy((i) => parseInt(i.order.en)).getItems();

  return collection
    .filter((i) => i.parent.id === null)
    .map((i) => {
      const children = collection.filter((i) => i.enabled).filter((c) => c.parent.id === i.id);

      return children ? { ...i, children } : i;
    });
};
